import { ReactNode } from "react";

interface LineProps {
	field: string | ReactNode;
	value: string | ReactNode;
	isText?: boolean;
}

export const SummaryLine = ({ field, value, isText }: LineProps) => (
	<div className="flex justify-between">
		<div className="text-sm text-gray-600 flex-1 max-w-sm break-words">
			{field}
		</div>
		<div
			className={`text-sm pl-2 text-right ${isText && "text-sm"} text-[#383838] flex-2`}
		>
			{value}
		</div>
	</div>
);
